import axios from 'axios';
import { configRefs } from '@utils/constants';

async function deactivateRevisionRequest(user, courseId) {
  if (!user || !user.institution?.id || !courseId) {
    throw new Error("deactivateRevisionRequest(): missing user data");
  }
  await axios.delete(`${await configRefs.apis.userdata.get()}/api/CourseRevisionsActivations/ResetActivation?userID=${encodeURIComponent(user.id)}&institutionID=${encodeURIComponent(user.institution.id)}&courseID=${encodeURIComponent(courseId)}`);
  return;
}

export { deactivateRevisionRequest };
//# sourceMappingURL=request.deactivate.js.map
